import { render, staticRenderFns } from "./ForgotPasswordModal.vue?vue&type=template&id=79efaffe&scoped=true&"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordModal.vue?vue&type=style&index=0&id=79efaffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79efaffe",
  null
  
)

export default component.exports